import { LineChart, Line, ResponsiveContainer, Tooltip, YAxis, XAxis, BarChart, Bar, Cell } from "recharts";

export const Head = ({ title, sub, refs = [], right }) => (
  <div className="page-h flex justify-between items-start gap-4 flex-wrap">
    <div>
      <h1>{title}{refs.map((r) => <span key={r} className="fr">{r}</span>)}</h1>
      {sub && <p>{sub}</p>}
    </div>
    {right}
  </div>
);

export const Card = ({ title, sub, children, flat, className = "", style, testId }) => (
  <div className={`card ${flat ? "flat" : ""} ${className}`} style={style} data-testid={testId}>
    {title && <h3>{title}</h3>}
    {sub && <div className="sub">{sub}</div>}
    {children}
  </div>
);

export const Tag = ({ kind = "", children, testId }) => <span className={`tag ${kind}`} data-testid={testId}>{children}</span>;
export const KV = ({ k, v, testId }) => <div className="kv" data-testid={testId}><span>{k}</span><span className="mono">{v}</span></div>;
export const Meter = ({ value, bad }) => <div className={`meter ${bad ? "bad" : ""}`}><i style={{ width: `${Math.max(0, Math.min(100, value))}%` }} /></div>;
export const Disclose = ({ children }) => <div className="disclose">{children}</div>;
export const Empty = ({ children, testId }) => <div className="empty" data-testid={testId}>{children}</div>;

export const Field = ({ label, children }) => (
  <div className="field"><label>{label}</label>{children}</div>
);

export const Stat = ({ label, value, sub, cls = "", testId }) => (
  <Card flat testId={testId}>
    <div className="rail-k">{label}</div>
    <div className={`stat mono ${cls}`}>{value}</div>
    {sub && <div className="sub" style={{ marginTop: 4 }}>{sub}</div>}
  </Card>
);

export const Modal = ({ open, onClose, title, children, testId }) => {
  if (!open) return null;
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} data-testid={testId}>
        <div className="flex justify-between items-center mb-3"><h2>{title}</h2>
          <button className="btn ghost sm" onClick={onClose} data-testid="modal-close-btn">Close</button></div>
        {children}
      </div>
    </div>
  );
};

const tipStyle = { background: "#1e212a", border: "1px solid #33353e", borderRadius: 6, fontSize: 12, color: "#f7f6f2" };

export const EquityChart = ({ data, height = 200, benchKey, benchLabel }) => (
  <div style={{ height }}>
    <ResponsiveContainer>
      <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <XAxis dataKey="t" hide />
        <YAxis domain={["auto", "auto"]} width={60} tick={{ fontSize: 11, fill: "#8b8a80", fontFamily: "IBM Plex Mono" }} axisLine={false} tickLine={false} />
        <Tooltip contentStyle={tipStyle} />
        <Line type="monotone" dataKey="equity" name="You" stroke="#c9a84c" strokeWidth={2} dot={false} isAnimationActive={false} connectNulls />
        {benchKey && <Line type="monotone" dataKey={benchKey} name={benchLabel || "Benchmark"} stroke="#8b8a80" strokeWidth={1.5} strokeDasharray="5 4" dot={false} isAnimationActive={false} connectNulls />}
      </LineChart>
    </ResponsiveContainer>
  </div>
);

export const Bars = ({ data, dataKey = "net", label = "key", height = 180 }) => (
  <div style={{ height }}>
    <ResponsiveContainer>
      <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <XAxis dataKey={label} tick={{ fontSize: 11, fill: "#8b8a80" }} axisLine={false} tickLine={false} />
        <YAxis width={50} tick={{ fontSize: 11, fill: "#8b8a80", fontFamily: "IBM Plex Mono" }} axisLine={false} tickLine={false} />
        <Tooltip contentStyle={tipStyle} cursor={{ fill: "rgba(201,168,76,.06)" }} />
        <Bar dataKey={dataKey} radius={[3, 3, 0, 0]} isAnimationActive={false}>
          {data.map((d, i) => <Cell key={i} fill={d[dataKey] >= 0 ? "#c9a84c" : "#e0736a"} />)}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </div>
);
